import { useContext, useEffect } from "react";
import { DataContext } from "../../context/Data.context";
import { Separator } from "@moreirapontocom/npmhelpers";
import { Link } from "react-router-dom";

const Help = () => {
  const { data, setData } = useContext(DataContext);

  const appVersion: string = process.env.REACT_APP_VERSION || "";

  useEffect(() => {
    setData({
      ...data,
      pageHeader: {
        title: "Help",
        backButton: true,
        previousPage: "/home",
      },
    });
  }, []);

  return <>
    <strong>Revolutionizing the world of diagnostic testing.</strong>

    <Separator size={20} />

    <p>
      Aptitude Medical Systems is a startup deep-tech healthcare company. 
      Our mission is democratizing diagnostics by empowering individuals to access their 
      health and diagnostic information anytime, anywhere. 
      Aptitude created a simple, accurate, and easy-to-use diagnostic platform that fits in the 
      palm of the hand and allows anyone to run a complex lab-quality PCR test in their own hands in minutes.
    </p>
    <p>
      Aptitude's lead product, Metrix® COVID-19 Test, is the first FDA-authorized molecular diagnostic test to work 
      with saliva or swab samples for at-home and over-the-counter use without physician supervision, and we have a 
      product pipeline that includes tests for a wide range of health and wellness conditions.
    </p>

    <Separator size={20} />

    ...

    <Separator size={20} />

    <div className="d-grid">
      <Link className="btn btn-primary btn-featured" to="/about">
        About
      </Link>
    </div>

    <Separator size={20} />

    <small className="text-muted">
      App Version: {appVersion}
    </small>

    <Separator size={160} />
  </>
};

export default Help;